export default "__VITE_ASSET__tlo$Zk1Z__"